import Vue from 'vue'

import {  addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import addressEditor from "@/extension/address-editor"

addCustomWidgetSchema({
  type: 'addressEditor',
  icon: 'alert',
  formItemFlag: true,
  options: {
    name: 'AddressEditor', // 唯一名称
    defaultValue:'430000000000,430100000000,430104000000,430104010000,430104010005', // 默认值
    defaultValuePlaceholder: '地址编码',
    label: '地址组件',
    labelAlign: 'label-right-align',
    columnWidth: '100%',
    labelWidth: '110',
    required: true,
    disabled: false,
    labelHidden: false,
    clearable: true,
    size: '',
    url:'/jumper-mih/nt/baseArea/areaList?parentId=',
    placeholder:'请选择',//输入提示文字
    customClass:'',
    requiredHint:'请选择',
    separator: ' / ', // 选项拼接符
    showAllLevels: false,  // 仅显示最后一级
    onChange:'',
    onBlur:''
  }
})  //加载组件Json Schema

Vue.component(addressEditor.name, addressEditor)  //注册组件
PERegister.registerCPEditor('url', 'url-editor',
    PEFactory.createInputTextEditor('url', '接口地址'))

PERegister.registerCPEditor('separator', 'separator-editor',
    PEFactory.createInputTextEditor('separator', '选项拼接符'))

PERegister.registerCPEditor('showAllLevels', 'showAllLevels-editor',
    PEFactory.createBooleanEditor('showAllLevels', '仅显示最后一级'))
